/**
 * @generated SignedSource<<1ddb95bbcdb9a7b40f1063fa499f8cc1>>
 * @relayHash 7b6d56299e8bad23570ed5580bdc5641
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6a5e4f4a4d3d13a42fadcbccaa10e14ae28ca67b7e22b87a8246aa660c4e7797

import type { ConcreteRequest } from 'relay-runtime';
export type useCommerceDeepLinksCcpEntitlementQuery$variables = Record<PropertyKey, never>;
export type useCommerceDeepLinksCcpEntitlementQuery$data = {
  readonly confluence_tenantContext: {
    readonly licenseStates: {
      readonly confluence: {
        readonly ccpEntitlementId: string | null;
      } | null;
    } | null;
  } | null;
  readonly tenant: {
    readonly cloudId: string;
  } | null;
};
export type useCommerceDeepLinksCcpEntitlementQuery = {
  response: useCommerceDeepLinksCcpEntitlementQuery$data;
  variables: useCommerceDeepLinksCcpEntitlementQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "LicenseStates",
        "kind": "LinkedField",
        "name": "licenseStates",
        "plural": false,
        "selections": [
          {
            "concreteType": "LicenseState",
            "kind": "LinkedField",
            "name": "confluence",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "Tenant",
    "kind": "LinkedField",
    "name": "tenant",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "cloudId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useCommerceDeepLinksCcpEntitlementQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useCommerceDeepLinksCcpEntitlementQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7b6d56299e8bad23570ed5580bdc5641",
    "id": "6a5e4f4a4d3d13a42fadcbccaa10e14ae28ca67b7e22b87a8246aa660c4e7797",
    "metadata": {},
    "name": "useCommerceDeepLinksCcpEntitlementQuery",
    "operationKind": "query",
    "text": "query useCommerceDeepLinksCcpEntitlementQuery{confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}},tenant{cloudId}}"
  }
};
})();

(node as any).hash = "f1b8b946a65b7c16eb6735dad6d5b323";

export default node;
